import { Link } from "react-router-dom";
import { filterCoursesWithDates } from "./../Registration";
export default function AdmissionCardHome() {
  return (
    <div className="bg-slate-100 p-5 md:p-16 my-24 rounded my-10">
      <div className="mb-10">
        <p className="text-center text-sky-900  text-3xl mb-4">
          আপনি আরো যে কোর্সগুলোতে ভর্তি হতে পারেন
        </p>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 ">
          {filterCoursesWithDates()
            .splice(0, 3)
            .map((course, i) => (
              <div
                key={i}
                className="shadow-xl relative overflow-hidden rounded-lg course_card p-10 bg-white"
              >
                <div className="flex items-center gap-5">
                  <img
                    width={40}
                    src="https://cdn-icons-gif.flaticon.com/12743/12743787.gif"
                    alt=""
                  />
                  <p className="text-xl">{course.name}</p>
                </div>
                <div>
                  {new Date() > new Date(course.flexibleAdmissionDate) ? (
                    <div>
                      <p>ভর্তি শেষ হয়েছে!</p>
                    </div>
                  ) : new Date() > new Date(course.admissionStartDate) ? (
                    <div>
                      <p>ভর্তি চলছে!</p>
                      <p>
                        ভর্তি শেষ হবে - <br /> {course.admissionEndDate}
                      </p>
                    </div>
                  ) : (
                    <p>
                      ভর্তি শুরু হবে - <br /> {course.admissionStartDate}
                    </p>
                  )}
                </div>
                <Link
                  className="underline mt-2 block"
                  to={`/courses/${course.course}`}
                >
                  বিস্তারিত দেখুন
                </Link>
              </div>
            ))}
          <div className="shadow-xl relative overflow-hidden rounded-lg course_card p-10 bg-white">
            <div className="flex flex-col items-center gap-5">
              <img
                width={80}
                src="https://cdn-icons-gif.flaticon.com/18996/18996454.gif"
                alt=""
              />
              <Link to="/courses">
                <p className="underline">সব কোর্স দেখুন</p>
              </Link>
            </div>
          </div>
          <div></div>
        </div>
      </div>
    </div>
  );
}
